import { STRAPI_URL, parseErrorMessage, strapiAuthHeaders } from '../../api/strapi';

export function uniqueFormQuestionNames(rows: Array<Record<string, unknown>>): string[] {
  const names = new Set<string>();
  for (const row of rows) {
    const name = String(row.form_question_name ?? '').trim();
    if (name) names.add(name);
  }
  return [...names].sort((a, b) => a.localeCompare(b, 'id'));
}

export function rowSelectionDocumentIds(model: unknown): string[] {
  if (!Array.isArray(model)) return [];
  const ids: string[] = [];
  const seen = new Set<string>();
  for (const item of model) {
    const id = String(item ?? '').trim();
    if (!id || seen.has(id)) continue;
    seen.add(id);
    ids.push(id);
  }
  return ids;
}

export type MapFormToJenisResult = {
  form_question_name: string;
  updated_count: number;
  jenis_pengukuran_count: number;
};

export async function strapiMapFormQuestionsToJenis(
  jwt: string,
  input: { formQuestionDocumentIds: string[]; jenisPengukuranDocumentIds: string[] },
): Promise<MapFormToJenisResult> {
  const formQuestionDocumentIds = rowSelectionDocumentIds(input.formQuestionDocumentIds);
  if (!formQuestionDocumentIds.length) throw new Error('Pilih minimal satu pertanyaan.');

  const res = await fetch(`${STRAPI_URL}/api/form-questions/map-form-to-jenis`, {
    method: 'POST',
    headers: {
      ...(strapiAuthHeaders(jwt) as Record<string, string>),
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      form_question_document_ids: formQuestionDocumentIds,
      jenis_pengukuran_document_ids: input.jenisPengukuranDocumentIds,
    }),
  });
  const body = (await res.json().catch(() => ({}))) as unknown;
  if (!res.ok) throw new Error(parseErrorMessage(body, res.status));
  const data =
    body && typeof body === 'object' && 'data' in body
      ? (body as { data?: Record<string, unknown> }).data
      : null;
  return {
    form_question_name: String(data?.form_question_name ?? ''),
    updated_count: Number(data?.updated_count ?? 0),
    jenis_pengukuran_count: Number(data?.jenis_pengukuran_count ?? 0),
  };
}
